class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        if (!this.detailsContainer || !this.summaryToggle) return;

        this.detailsContainer.addEventListener(
            'keyup',
            (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
        );

        this.summaryToggle.addEventListener(
            'click',
            this.onSummaryClick.bind(this)
        );

        this.querySelectorAll('button:not([type="submit"])').forEach((button) => {
            button.addEventListener('click', this.close.bind(this));
        });

        this.summaryToggle.setAttribute('role', 'button');
        this.summaryToggle.setAttribute('aria-expanded', 'false');
    }

    isOpen() {
        return this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();
        // Allow event to bubble so other scripts (like theme.js sidebar search) can see it
        const details = event.currentTarget.closest('details');
        if (details.hasAttribute('open')) {
            this.close();
        } else {
            this.open(details);
        }
    }

    onBodyClick(event) {
        if (!this.contains(event.target)) this.close(false);
    }

    open(details) {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        details.setAttribute('open', true);
        this.summaryToggle.setAttribute('aria-expanded', true);
        document.body.addEventListener('click', this.onBodyClickEvent);

        if (window.trapFocus) {
            trapFocus(this.detailsContainer, details.querySelector('input:not([type="hidden"])'));
        }

        const input = details.querySelector('input:not([type="hidden"]):not([readonly])') || details.querySelector('input:not([type="hidden"])');
        if (input) {
            setTimeout(() => {
                input.focus();
            }, 200);
        }
    }

    close(focusToggle = true) {
        if (window.removeTrapFocus) {
            removeTrapFocus(focusToggle ? this.summaryToggle : null);
        }
        this.detailsContainer.removeAttribute('open');
        this.summaryToggle.setAttribute('aria-expanded', false);
        document.body.removeEventListener('click', this.onBodyClickEvent);
        if (focusToggle && this.summaryToggle) {
            this.summaryToggle.focus();
        }
    }
}

if (!customElements.get('details-modal')) {
    customElements.define('details-modal', DetailsModal);
}
